import { useEffect } from 'react';

export const PromotionalTerms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto h-auto w-full px-8 pb-8 pt-20'>
          <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
            <div className='grid-rows col-span-full grid content-center gap-y-4 lg:gap-y-8'>
              <h1 className='row-auto text-3xl font-bold lg:text-4xl'>PLAYCAST PROMOTIONAL OFFER TERMS AND CONDITIONS</h1>
              <p className='row-auto'>Last Updated: 31 October 2025</p>
              <br />
            </div>
          </section>
        </div>
      </div>

      <div className='bg-content-secondary text-content-text m-0 h-auto w-full'>
        <div className='container mx-auto h-auto w-full px-8 py-20'>
          <section className='grid grid-cols-12 gap-10 md:gap-8'>
            <h2 className='col-span-full text-2xl font-bold'>1. PROMOTIONAL OFFER OVERVIEW</h2>
            <p className='col-span-full -mt-4'>
              This promotional offer (the "Offer") is provided by Playcast, Inc., a Washington corporation with
              principal place of business at 1000 SE Everett Mall Way #400, Everett, WA 98208 ("Playcast," "we," "us," or "our").
            </p>
            <p className='col-span-full -mt-4'>
              Under this limited-time Offer, eligible participants who download, install, and activate the Playcast
              application during the Offer Period (defined below) will receive one (1) reward consisting of either: (a)
              a Ten Dollar ($10.00 USD) Steam digital gift card, or (b) a digital game key (the "Reward"), subject to
              availability and these Terms and Conditions (the "Terms").
            </p>
            <p className='col-span-full -mt-4'>
              This is a limited promotional offer available to the first 250 eligible participants only.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>2. ELIGIBILITY</h2>
            <p className='col-span-full -mt-4'>This Offer is available only to individuals who meet ALL of the following requirements:</p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Are legal residents of the United States (including the fifty (50) states and the District of Columbia) or Canada (excluding Quebec)</li>
              <li>Are at least eighteen (18) years of age or the age of majority in their jurisdiction of residence, whichever is older, as of the date of participation</li>
              <li>Have a valid email address</li>
              <li>Have a compatible PC that meets the minimum system requirements for the Playcast application</li>
              <li>Have not previously received a Reward under this Offer or any prior Playcast promotional offer</li>
              <li>Are not employees, officers, directors, contractors, or agents of Playcast, or immediate family members or household members of such persons</li>
            </ul>
            <p className='col-span-full -mt-4'>
              <strong>Quebec Exclusion:</strong> This Offer is not available to residents of Quebec due to provincial regulatory requirements.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Void Where Prohibited:</strong> This Offer is void where prohibited or restricted by law.
            </p>
            <p className='col-span-full -mt-4'>
              Employees, officers, directors, contractors, and agents of Playcast, its parent companies, subsidiaries,
              affiliates, and their respective immediate family members (spouse, parent, child, sibling, and their
              respective spouses) and household members (whether related or not) are not eligible to participate.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>3. OFFER PERIOD</h2>
            <p className='col-span-full -mt-4'>
              This Offer is valid from October 31st, 2025 at 10:00AM Pacific Time through November 30th, 2025 at 11:59PM Pacific Time, or
              until 250 Rewards have been claimed, whichever occurs first (the "Offer Period").
            </p>
            <p className='col-span-full -mt-4'>
              Playcast reserves the right to modify or terminate this Offer at any time for any reason, including if the
              allocated Rewards are exhausted prior to the stated end date.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>4. HOW TO PARTICIPATE</h2>
            <p className='col-span-full -mt-4'>
              To receive a Reward under this Offer, you must complete ALL of the following steps during the Offer Period:
            </p>
            <ol className='col-span-10 col-start-2 -mt-4 list-decimal space-y-2'>
              <li>Visit playcast.io or any campaign websites found at playcast.io/host/&lt;campaign-title&gt;</li>
              <li>Create a Playcast account or authenticate with your existing account</li>
              <li>Download the Playcast application for PC</li>
              <li>Install the Playcast application on your compatible PC</li>
              <li>Complete the installation process and successfully activate your PC on the Playcast network</li>
              <li>Provide a valid email address for Reward delivery</li>
              <li>Accept the Playcast End User License Agreement and Terms of Service</li>
            </ol>
            <p className='col-span-full -mt-4'>
              <strong>Reward Allocation:</strong> Rewards will be allocated on a first-come, first-served basis to the
              first 250 eligible participants who complete all steps above. Once all Rewards have been claimed, no
              additional Rewards will be available.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Participation Restrictions:</h3>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li><strong>Per-Campaign Limit:</strong> One (1) Reward per person, per household, per email address, and per PC for this specific Offer</li>
              <li><strong>Annual Limit for Steam Gift Cards:</strong> Participants may receive a maximum of five (10) Steam gift card rewards (or $100 USD in aggregate Steam gift card value, whichever is less) per calendar year across all Playcast promotional campaigns and offers. This annual limit does not apply to digital game key rewards.</li>
              <li>Multiple accounts, email addresses, or attempts to claim multiple Rewards beyond permitted limits will result in disqualification and forfeiture of all Rewards</li>
              <li>Use of automated systems, bots, scripts, or any method designed to circumvent participation limits is strictly prohibited and will result in immediate disqualification</li>
              <li>Playcast reserves the right to verify eligibility, track participation across multiple campaigns, and disqualify any participant suspected of fraudulent activity or circumvention of participation limits</li>
              <li>Playcast may deny Rewards if issuing the Reward would cause a participant to exceed annual limits</li>
            </ul>

            <h2 className='col-span-full text-2xl font-bold'>5. REWARD DETAILS</h2>
            <p className='col-span-full -mt-4'>
              <strong>Reward Options:</strong> Each Reward consists of one (1) of the following, at Playcast's sole discretion based on availability:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Option A: One (1) Ten Dollar ($10.00 USD) Steam digital gift card; or</li>
              <li>Option B: One (1) digital game key for a title selected by Playcast</li>
            </ul>
            <p className='col-span-full -mt-4'>
              <strong>Annual Participation Cap:</strong> To ensure broad distribution and compliance with tax reporting
              requirements, participants are limited to a maximum of five (5) Steam gift card rewards (or $100 USD aggregate
              value in Steam gift cards) per calendar year across all Playcast promotional offers. Digital game key rewards
              are not subject to this annual cap. If you have reached your annual limit for Steam gift cards, you may still
              participate in Playcast offers for digital game key rewards only.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Approximate Value:</strong> Up to $10.00 USD (or CAD equivalent) per Reward.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Total Available:</strong> Up to 250 total Rewards available under this specific Offer.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Reward Delivery:</h3>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Rewards will be delivered electronically via email to the address provided during registration</li>
              <li>Delivery will occur within approximately 30 business days after verification of eligibility and completion of all participation requirements</li>
              <li>Playcast is not responsible for email delivery failures, spam filters, email provider issues, or incorrect email addresses provided by participants</li>
              <li>It is your responsibility to ensure you can receive emails from Playcast and to check your spam/junk folders</li>
            </ul>

            <h3 className='col-span-full text-xl font-bold mt-4'>Reward Limitations and Restrictions:</h3>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Rewards have no cash value and cannot be redeemed for cash</li>
              <li>Rewards are non-transferable and non-assignable</li>
              <li>Rewards may not be sold, auctioned, or exchanged</li>
              <li>No substitution of Reward is permitted by participant</li>
              <li>Playcast reserves the right to substitute a Reward with one of equal or greater value if the designated Reward becomes unavailable</li>
              <li>Steam gift cards are subject to Valve Corporation's Steam Subscriber Agreement and applicable terms, available at https://store.steampowered.com/subscriber_agreement/</li>
              <li>Game keys must be redeemed according to the applicable platform's terms of service and may have expiration dates or geographic restrictions</li>
              <li>Participants are solely responsible for any applicable taxes, fees, duties, or other charges associated with Reward receipt or use</li>
              <li>For Canadian participants, goods and services tax (GST/HST) may apply</li>
              <li>Unclaimed Rewards or Rewards that cannot be delivered will be forfeited with no compensation</li>
            </ul>

            <h2 className='col-span-full text-2xl font-bold'>6. VERIFICATION AND ELIGIBILITY CONFIRMATION</h2>
            <p className='col-span-full -mt-4'>
              Playcast reserves the right to verify the eligibility of all participants. Verification may include but is not limited to:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Confirming age and residency</li>
              <li>Verifying that the Playcast application has been properly installed and activated</li>
              <li>Confirming compliance with these Terms</li>
              <li>Investigating potential fraudulent activity or Terms violations</li>
            </ul>
            <p className='col-span-full -mt-4'>
              Participants may be required to provide proof of eligibility, including government-issued identification, proof
              of residence, or other documentation. Failure to provide requested documentation within 7 days may result in
              disqualification and forfeiture of the Reward.
            </p>
            <p className='col-span-full -mt-4'>
              Any participant found to be ineligible, in violation of these Terms, or engaged in fraudulent activity will be
              disqualified, and any Reward claimed will be forfeited and revoked.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>7. PLAYCAST APPLICATION AND SERVICES</h2>
            <p className='col-span-full -mt-4'>
              <strong>Application Functionality:</strong> The Playcast application enables your PC to serve as a game streaming
              host within the Playcast cloud gaming network. When your computer is idle, it may host game streaming sessions
              for other Playcast users. By installing the application, you agree to this functionality.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Separate Agreement:</strong> Your download, installation, and use of the Playcast application is governed
              by our End User License Agreement (EULA) and Terms of Service, available at https://playcast.io/eula and
              https://playcast.io/terms-of-service, respectively. These documents are separate from and in addition to these
              Offer Terms. In the event of any conflict between these Offer Terms and the EULA/Terms of Service, the EULA/Terms
              of Service shall control with respect to your use of the Playcast application.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Continued Use Not Required:</strong> While installation and activation are required to receive the Reward,
              you are not required to maintain the Playcast application on your PC after receiving your Reward. You may
              uninstall the application at any time in accordance with the EULA.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>System Requirements:</strong> Your PC must meet minimum system requirements as specified on the Playcast
              website. Playcast is not responsible if your PC does not meet these requirements or if you experience technical
              difficulties.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>8. PRIVACY AND DATA COLLECTION</h2>
            <p className='col-span-full -mt-4'>
              <strong>Data Collection:</strong> By participating in this Offer, you acknowledge and agree that Playcast will
              collect, use, process, and store personal information, including but not limited to:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Your name, email address, and country of residence</li>
              <li>Account registration information</li>
              <li>IP address and device information</li>
              <li>Technical data related to the Playcast application installation and usage</li>
              <li>Payment information for tax reporting purposes (if applicable)</li>
            </ul>

            <p className='col-span-full -mt-4'><strong>Purpose of Data Use:</strong></p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>To administer this Offer and verify eligibility</li>
              <li>To deliver Rewards</li>
              <li>To operate and improve the Playcast platform</li>
              <li>To comply with legal and tax obligations</li>
              <li>To prevent fraud and enforce these Terms</li>
              <li>To communicate with you about the Offer and Playcast services</li>
            </ul>

            <p className='col-span-full -mt-4'>
              <strong>Privacy Policy:</strong> All personal information collected is subject to Playcast's Privacy Policy,
              available at https://playcast.io/privacy-policy, which is incorporated into these Terms by reference. Please
              review the Privacy Policy to understand how we collect, use, and protect your information.
            </p>

            <p className='col-span-full -mt-4'>
              <strong>Your Privacy Rights:</strong> Depending on your location, you may have certain rights regarding your
              personal data, including:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>US Residents: Rights under applicable state privacy laws (including CCPA for California residents)</li>
              <li>Canadian Residents: Rights under PIPEDA and provincial privacy legislation</li>
            </ul>
            <p className='col-span-full -mt-4'>
              For more information about your privacy rights and how to exercise them, please refer to our Privacy Policy or
              contact us at host.rewards@playcast.io.
            </p>

            <p className='col-span-full -mt-4'>
              <strong>Cross-Border Data Transfer:</strong> If you are a Canadian resident, your personal information may be
              transferred to and processed in the United States, where our servers and operations are located. By participating,
              you consent to this transfer.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>9. INTELLECTUAL PROPERTY AND LICENSE GRANT</h2>
            <p className='col-span-full -mt-4'>
              <strong>Playcast IP:</strong> All content related to this Offer, including trademarks, service marks, logos,
              designs, text, graphics, software, and other materials, is the exclusive property of Playcast or its licensors
              and is protected by copyright, trademark, patent, and other intellectual property laws. You may not use,
              reproduce, modify, or distribute any such content without express written permission from Playcast.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Promotional Rights:</strong> By participating in this Offer, you grant Playcast and its designees a
              non-exclusive, perpetual, irrevocable, worldwide, royalty-free license and right to use, publish, and display
              your name, city and province/state of residence, testimonials, and statements about the Offer for advertising,
              marketing, promotional, and other commercial purposes in any media now known or hereafter developed, without
              additional compensation or approval, except where prohibited by law.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Right to Opt-Out:</strong> If you do not wish to grant these promotional rights, you may opt out by
              sending written notice to 1000 SE Everett Mall Way #400, Everett, WA 98208 within 14 days of participating in the Offer.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>10. REPRESENTATIONS AND WARRANTIES</h2>
            <p className='col-span-full -mt-4'>By participating in this Offer, you represent and warrant that:</p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>All information you provide is accurate, current, and complete</li>
              <li>You meet all eligibility requirements</li>
              <li>You have the legal capacity to enter into these Terms</li>
              <li>Your participation does not violate any applicable laws or third-party rights</li>
              <li>You have not and will not use automated means to participate</li>
              <li>You will comply with all Terms and applicable laws</li>
            </ul>

            <h2 className='col-span-full text-2xl font-bold'>11. DISCLAIMER OF WARRANTIES</h2>
            <p className='col-span-full -mt-4'>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, THIS OFFER AND ALL REWARDS ARE PROVIDED "AS IS" AND "AS AVAILABLE"
              WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
            </p>
            <p className='col-span-full -mt-4'>PLAYCAST DOES NOT WARRANT THAT:</p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>The Offer will be uninterrupted, secure, or error-free</li>
              <li>Rewards will meet your expectations or requirements</li>
              <li>Any errors or defects will be corrected</li>
              <li>The Playcast application will function without interruption or errors</li>
            </ul>
            <p className='col-span-full -mt-4'>
              Some jurisdictions do not allow the exclusion of implied warranties, so some of the above exclusions may not
              apply to you. You may have other rights that vary by jurisdiction.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>12. LIMITATION OF LIABILITY AND RELEASE</h2>
            <p className='col-span-full -mt-4'>
              <strong>Release of Claims:</strong> By participating in this Offer, you hereby release, discharge, and hold
              harmless Playcast and its parent companies, subsidiaries, affiliates, partners, licensors, directors, officers,
              employees, agents, representatives, successors, and assigns (collectively, the "Released Parties") from any and
              all claims, demands, damages, losses, liabilities, costs, expenses (including reasonable attorneys' fees), causes
              of action, suits, or judgments of any kind or nature arising out of, relating to, or connected with:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Your participation in this Offer</li>
              <li>Your receipt, use, misuse, or inability to use any Reward</li>
              <li>Your installation or use of the Playcast application</li>
              <li>Any technical failures, malfunctions, or errors</li>
              <li>Unauthorized access to or alteration of your data or transmissions</li>
              <li>Any injury, loss, or damage of any kind arising from participation in this Offer</li>
              <li>Any disputes with other participants or third parties</li>
            </ul>

            <p className='col-span-full -mt-4'>
              <strong>Limitation of Liability:</strong> TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE RELEASED
              PARTIES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES (INCLUDING
              BUT NOT LIMITED TO LOSS OF PROFITS, REVENUE, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES) ARISING OUT OF OR
              RELATED TO THIS OFFER OR THESE TERMS, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p className='col-span-full -mt-4'>
              TO THE EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF THE RELEASED PARTIES FOR ANY CLAIMS RELATED TO THIS OFFER
              SHALL NOT EXCEED THE VALUE OF THE REWARD, OR TWENTY DOLLARS ($20.00 USD), WHICHEVER IS LESS.
            </p>
            <p className='col-span-full -mt-4'>
              Some jurisdictions do not allow the limitation or exclusion of liability for incidental or consequential damages,
              so the above limitations may not apply to you.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>13. INDEMNIFICATION</h2>
            <p className='col-span-full -mt-4'>
              You agree to indemnify, defend, and hold harmless the Released Parties from and against any and all claims,
              demands, liabilities, damages, losses, costs, and expenses (including reasonable attorneys' fees) arising out of
              or related to:
            </p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Your violation of these Terms</li>
              <li>Your violation of any applicable law or regulation</li>
              <li>Your violation of any third-party rights</li>
              <li>Your use or misuse of any Reward</li>
              <li>Any fraudulent or illegal activity by you in connection with this Offer</li>
            </ul>

            <h2 className='col-span-full text-2xl font-bold'>14. MODIFICATION, SUSPENSION, AND TERMINATION</h2>
            <p className='col-span-full -mt-4'>Playcast reserves the right, in its sole discretion, to:</p>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>Modify, suspend, or terminate this Offer at any time for any reason</li>
              <li>Modify these Terms at any time (modifications will be effective upon posting)</li>
              <li>Disqualify any participant who violates these Terms or engages in conduct Playcast deems inappropriate</li>
              <li>Cancel, modify, or suspend the Offer if fraud, technical failures, force majeure, or any other factor beyond Playcast's reasonable control impairs the integrity or proper functioning of the Offer</li>
            </ul>
            <p className='col-span-full -mt-4'>
              In the event of termination, Playcast will honor Rewards for participants who completed all requirements prior to
              termination, but shall have no further obligations under this Offer.
            </p>
            <p className='col-span-full -mt-4'>
              Notice of material changes will be provided by posting updated Terms with a new "Last Updated" date. Continued
              participation following any modification constitutes acceptance of the modified Terms.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>15. DISPUTE RESOLUTION AND GOVERNING LAW</h2>
            <h3 className='col-span-full text-xl font-bold mt-4'>Governing Law:</h3>
            <ul className='col-span-10 col-start-2 -mt-4 list-disc space-y-2'>
              <li>For US participants: These Terms shall be governed by and construed in accordance with the laws of the State of Washington, without regard to its conflict of law principles.</li>
              <li>For Canadian participants: These Terms shall be governed by and construed in accordance with the federal laws of Canada applicable therein and the laws of the Province of British Columbia, without regard to conflict of law principles.</li>
            </ul>

            <h3 className='col-span-full text-xl font-bold mt-4'>Arbitration Agreement (US Participants Only):</h3>
            <p className='col-span-full -mt-4'>
              Any dispute, claim, or controversy arising out of or relating to these Terms or the Offer shall be resolved by
              binding arbitration administered by the American Arbitration Association ("AAA") in accordance with its Consumer
              Arbitration Rules, rather than in court. The arbitration shall be conducted in King County, Washington, or at
              another mutually agreeable location. Judgment on the arbitration award may be entered in any court having
              jurisdiction.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Exceptions to Arbitration:</h3>
            <p className='col-span-full -mt-4'>
              Either party may bring suit in court to enjoin infringement or other misuse of intellectual property rights, or
              seek relief in small claims court for disputes within that court's jurisdiction.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Class Action Waiver (US Participants):</h3>
            <p className='col-span-full -mt-4'>
              YOU AGREE THAT ANY ARBITRATION OR COURT PROCEEDING SHALL BE LIMITED TO THE DISPUTE BETWEEN YOU AND PLAYCAST
              INDIVIDUALLY. TO THE FULL EXTENT PERMITTED BY LAW: (A) NO ARBITRATION OR PROCEEDING SHALL BE JOINED WITH ANY
              OTHER; (B) THERE IS NO RIGHT OR AUTHORITY FOR ANY DISPUTE TO BE ARBITRATED OR RESOLVED ON A CLASS-ACTION BASIS OR
              TO UTILIZE CLASS ACTION PROCEDURES; AND (C) THERE IS NO RIGHT OR AUTHORITY FOR ANY DISPUTE TO BE BROUGHT IN A
              PURPORTED REPRESENTATIVE CAPACITY ON BEHALF OF THE GENERAL PUBLIC OR ANY OTHER PERSONS.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Arbitration Opt-Out (US Participants):</h3>
            <p className='col-span-full -mt-4'>
              You may opt out of the arbitration agreement by sending written notice of your decision to 1000 SE Everett Mall Way #400, Everett, WA 98208 within thirty
              (30) days of accepting these Terms. If you opt out, disputes will be resolved in the state or federal courts
              located in King County, Washington, and you consent to personal jurisdiction in such courts.
            </p>

            <h3 className='col-span-full text-xl font-bold mt-4'>Canadian Participants - Jurisdiction:</h3>
            <p className='col-span-full -mt-4'>
              Canadian participants agree that any legal action or proceeding arising out of or related to these Terms or the
              Offer shall be brought exclusively in the courts of the Province of British Columbia, and you irrevocably submit
              to the jurisdiction of such courts.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>16. GENERAL PROVISIONS</h2>
            <p className='col-span-full -mt-4'>
              <strong>Entire Agreement:</strong> These Terms, together with the Playcast Privacy Policy, EULA, and Terms of
              Service (to the extent applicable), constitute the entire agreement between you and Playcast regarding this Offer
              and supersede all prior or contemporaneous communications and proposals.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Severability:</strong> If any provision of these Terms is found to be invalid, illegal, or unenforceable,
              the remaining provisions shall continue in full force and effect. The invalid provision shall be modified to the
              minimum extent necessary to make it valid and enforceable.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Waiver:</strong> Playcast's failure to enforce any provision of these Terms shall not constitute a waiver
              of that provision or any other provision. No waiver shall be effective unless in writing and signed by an
              authorized representative of Playcast.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Assignment:</strong> You may not assign, transfer, or delegate these Terms or your rights and obligations
              hereunder without Playcast's prior written consent. Playcast may freely assign these Terms. These Terms shall be
              binding upon and inure to the benefit of the parties and their respective successors and permitted assigns.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Force Majeure:</strong> Playcast shall not be liable for any failure or delay in performance under these
              Terms due to causes beyond its reasonable control, including acts of God, war, terrorism, labor disputes, internet
              or telecommunications failures, or government actions.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Survival:</strong> Provisions that by their nature should survive termination of this Offer shall survive,
              including but not limited to Sections 9, 11, 12, 13, and 15.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Language:</strong> These Terms are drafted in English. If these Terms are translated into any other
              language, the English version shall prevail in the event of any inconsistency or dispute.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Captions:</strong> Section headings are for convenience only and shall not affect the interpretation of these Terms.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>17. PARTICIPANT LIST</h2>
            <p className='col-span-full -mt-4'>
              A list of Reward recipients (first name, last initial, city, state/province) may be obtained by sending a written
              request with a self-addressed stamped envelope to 1000 SE Everett Mall Way #400, Everett, WA 98208, Attn: Playcast Offer Recipient List, to be received
              within ninety (90) days after the conclusion of the Offer Period.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>18. TAX OBLIGATIONS</h2>
            <p className='col-span-full -mt-4'>
              <strong>Recipient Tax Responsibility:</strong> You are solely responsible for reporting and paying any applicable
              federal, state, provincial, and local taxes on Rewards received. The fair market value of Rewards may constitute
              taxable income under applicable tax laws. Playcast does not provide tax advice, and you should consult with a
              qualified tax professional regarding your specific tax obligations.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Fair Market Value:</strong> For tax reporting purposes, the fair market value of Rewards will be
              determined by Playcast in its reasonable discretion based on factors including but not limited to acquisition cost,
              transferability, market liquidity, use restrictions, and promotional context. Steam gift cards will be valued at
              their face value. Digital game keys received by Playcast for promotional distribution purposes will be valued based
              on Playcast's acquisition cost and applicable use restrictions, which may result in a nominal or zero fair market
              value for tax reporting purposes.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Information Reporting (US Participants):</strong> Playcast has implemented annual participation limits
              designed to keep individual reward values below federal tax reporting thresholds. However, Playcast may be required
              to report Reward values to the Internal Revenue Service and issue Form 1099-MISC or other applicable tax forms if
              you receive Rewards with an aggregate fair market value of $600 USD or more within a calendar year from Playcast
              (including from sources outside this Offer). If reporting is required, you agree to provide any information
              reasonably requested by Playcast for tax reporting purposes, including but not limited to your Social Security
              Number or Taxpayer Identification Number, within 7 days of request. Failure to provide required information may
              result in backup withholding or forfeiture of future Rewards.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Information Reporting (Canadian Participants):</strong> Playcast may be required to report Reward values to
              the Canada Revenue Agency and issue Form T4A or other applicable tax forms as required by law. You agree to provide
              any information reasonably requested by Playcast for tax reporting purposes, including but not limited to your
              Social Insurance Number, within 7 days of request.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Goods and Services Tax (Canadian Participants):</strong> The value of Rewards may be subject to goods and
              services tax (GST), harmonized sales tax (HST), or provincial sales tax (PST) depending on your province of
              residence. You are responsible for determining and paying any applicable sales taxes.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Record Keeping:</strong> Playcast will maintain records of Reward distribution and fair market values for
              tax reporting purposes in accordance with applicable law. You should maintain your own records of Rewards received
              for tax reporting purposes.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>No Tax Advice:</strong> Nothing in these Terms constitutes tax advice. The tax treatment of promotional
              rewards may vary based on individual circumstances. You are encouraged to consult with a qualified tax professional.
            </p>

            <h2 className='col-span-full text-2xl font-bold'>19. CONTACT INFORMATION</h2>
            <p className='col-span-full -mt-4'>
              <strong>Sponsor and Administrator:</strong><br />
              Playcast, Inc.<br />
              1000 SE Everett Mall Way #400<br />
              Everett, WA 98208<br />
              United States of America
            </p>
            <p className='col-span-full -mt-4'>
              <strong>For Questions About This Offer:</strong><br />
              Email: host.rewards@playcast.io
            </p>
            <p className='col-span-full -mt-4'>
              <strong>For Privacy Inquiries:</strong><br />
              Email: host.rewards@playcast.io
            </p>
            <p className='col-span-full -mt-4'>
              <strong>For Legal Notices:</strong><br />
              Email: host.rewards@playcast.io
            </p>

            <h2 className='col-span-full text-2xl font-bold'>20. SPECIFIC PROVISIONS FOR CANADIAN PARTICIPANTS</h2>
            <p className='col-span-full -mt-4'>
              <strong>Language:</strong> These Terms are available in English. Si vous souhaitez recevoir ces conditions en
              français, veuillez communiquer avec nous. / If you would like to receive these terms in French, please contact us.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Quebec Exclusion:</strong> As stated in Section 2, residents of Quebec are not eligible for this Offer due
              to provincial regulatory requirements.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Consumer Protection:</strong> Nothing in these Terms limits or excludes any consumer rights you may have
              under applicable Canadian consumer protection legislation that cannot be lawfully excluded.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Currency:</strong> All dollar amounts referenced in these Terms are in United States Dollars (USD). The
              approximate Canadian Dollar (CAD) equivalent will be calculated at the time of Reward delivery using prevailing
              exchange rates.
            </p>
            <p className='col-span-full -mt-4'>
              <strong>Privacy:</strong> Canadian participants' personal information is subject to PIPEDA (Personal Information
              Protection and Electronic Documents Act) and provincial privacy legislation. Please review our Privacy Policy for
              details on how we protect your information.
            </p>

            <div className='col-span-full my-8 border-t-2 border-content-text/20'></div>

            <p className='col-span-full text-center font-bold text-lg'>
              BY PARTICIPATING IN THIS OFFER, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE
              TERMS AND CONDITIONS AND ALL DECISIONS OF PLAYCAST, WHICH ARE FINAL AND BINDING.
            </p>

            <div className='col-span-full my-8 border-t-2 border-content-text/20'></div>

            <p className='col-span-full text-center text-sm'>
              These Terms and Conditions were last updated on 31 October 2025.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
